import { SignIn, SignUp } from "@clerk/react";
import { BrandMark } from "@/components/Brand";

const Shell = ({ children }) => (
  <div className="flex min-h-[100dvh] bg-zap-mist">
    <aside className="hidden w-[420px] flex-col justify-between bg-zap-deep p-10 text-white lg:flex">
      <div>
        <BrandMark className="h-40" testId="signin-logo" />
        <p className="mt-6 font-display text-3xl font-semibold tracking-wide">ZAP IUDP</p>
        <p className="mt-1 uppercase tracking-[0.14em] text-[#E2C27A]">Central Digital</p>
      </div>
      <div className="space-y-3 text-[15px] text-white/80">
        <p className="font-display text-xl text-[#E2C27A]">Painel de atendimento</p>
        <p>Acesso restrito à equipe autorizada. Novos acessos ficam aguardando aprovação de um administrador.</p>
      </div>
      <p className="text-sm text-white/50">Dados tratados conforme a LGPD.</p>
    </aside>
    <main className="flex flex-1 items-center justify-center p-4">{children}</main>
  </div>
);

export const SignInPage = () => (
  <Shell><SignIn routing="path" path="/admin/entrar" signUpUrl="/admin/cadastro" withSignUp fallbackRedirectUrl="/admin/conversas" /></Shell>
);

export const SignUpPage = () => (
  <Shell><SignUp routing="path" path="/admin/cadastro" signInUrl="/admin/entrar" fallbackRedirectUrl="/admin" /></Shell>
);
